export default class DownPaymentActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static VIEW_DATA_IN='VIEW_DATA_IN';
  static VIEW_DATA_OUT='VIEW_DATA_OUT';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_DOWNPAYMENT='GET_HELPER_DOWNPAYMENT';
  static GET_HELPERFULL_DOWNPAYMENT='GET_HELPERFULL_DOWNPAYMENT';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static VOID_DATA="VOID_DATA";

  static submit(){
    return {
      type: DownPaymentActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: DownPaymentActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: DownPaymentActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: DownPaymentActions.VIEW_DATA,
      payload: data
    };
  }

  static viewDataIn(dataIn) {
    return {
      type: DownPaymentActions.VIEW_DATA_IN,
      payload: dataIn
    };
  }

  static viewDataOut(dataOut) {
    return {
      type: DownPaymentActions.VIEW_DATA_OUT,
      payload: dataOut
    };
  }

  static delete(data) {
    return {
      type: DownPaymentActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: DownPaymentActions.SHOW_DATA,
      payload: data
    };
  }
  static error(error){
    return {
      type: DownPaymentActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: DownPaymentActions.SUCCESS_DATA,
    };
  }
  static void(data) {
    return {
      type: DownPaymentActions.VOID_DATA,
      payload: data
    };
    
  }
  static process(){
    return {
      type: DownPaymentActions.PROCESS_DATA,
    };
  }
  static resetList(){
    return {
      type: DownPaymentActions.RESET_LIST,
    };
  }
  static reset(){
    return {
      type: DownPaymentActions.RESET_DATA,
    };
  }
  static helper(helperDownPayment){
    return {
      type: DownPaymentActions.GET_HELPER_DOWNPAYMENT,
      payload:helperDownPayment
    };
  }
  static helperFull(data){
    return {
      type: DownPaymentActions.GET_HELPERFULL_DOWNPAYMENT,
      payload:data
    };
  }

  static errorInternal(error){
    return {
      type: DownPaymentActions.ERROR_SERVER,
      payload: error
    };
  }
}